var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutboundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 36C40 38.7614 37.7614 41 35 41C32.2386 41 30 38.7614 30 36C30 33.2386 32.2386 31 35 31C37.7614 31 40 33.2386 40 36Z",
    stroke: "#9E874A",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36C20 38.7614 17.7614 41 15 41C12.2386 41 10 38.7614 10 36C10 33.2386 12.2386 31 15 31C17.7614 31 20 33.2386 20 36Z",
    stroke: "#9E874A",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36H20M40 36H41.5264C41.9662 36 42.1862 36 42.371 35.977C43.7338 35.8072 44.8072 34.7338 44.977 33.371C45 33.1862 45 32.9662 45 32.5264V27C45 19.8203 39.1798 14 32 14M31 32V15C31 12.1716 31 10.7574 30.1214 9.87868C29.2426 9 27.8284 9 25 9H11C8.17158 9 6.75736 9 5.87868 9.87868C5 10.7574 5 12.1716 5 15V31C5 32.8692 5 33.8038 5.40192 34.5C5.66522 34.956 6.04394 35.3348 6.5 35.598C7.19616 36 8.13076 36 10 36",
    stroke: "#9E874A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundIcon);
export default __webpack_public_path__ + "static/media/OutboundIcon.43f7ea00011e92e2480fe1c9442a40ee.svg";
export { ForwardRef as ReactComponent };